import { useEffect, useState } from "react";

import { fetchSupportAnnouncements } from "@/lib/fetch-api/support-announcements";
import type { SupportAnnouncement } from "@/lib/fetch-api/support-announcements";

export type { SupportAnnouncement } from "@/lib/fetch-api/support-announcements";

/**
 * お知らせ一覧を support サイトから取得する。
 * 取得前・取得失敗時は undefined を返し、呼び出し側はニュース欄ごと非表示にする。
 *
 * 失敗時に空配列を返さないのは、既読履歴の剪定が「現存するお知らせ」を基準に走るため。
 * 取得できなかっただけで既読が全消しになるのを避ける。
 */
export const useSupportAnnouncements = () => {
	const [announcements, setAnnouncements] = useState<SupportAnnouncement[]>();

	useEffect(() => {
		const controller = new AbortController();

		const fetchAnnouncements = async () => {
			try {
				const items = await fetchSupportAnnouncements(controller.signal);
				if (controller.signal.aborted) return;
				setAnnouncements(items);
			} catch {
				// アンマウント時の中断は失敗ではないので握りつぶす
				if (controller.signal.aborted) return;
			}
		};

		void fetchAnnouncements();

		return () => controller.abort();
	}, []);

	return announcements;
};
